var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerkaufsunterlagen = function SvgVerkaufsunterlagen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#637384",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    clipPath: "url(#Verkaufsunterlagen_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.27 14.86h7.64M10.09 11.05v7.63M20.59 22.5H3.41a1.92 1.92 0 0 1-1.91-1.91V7.23h17.18v13.36a1.92 1.92 0 0 0 1.91 1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 3.41v17.18a1.91 1.91 0 1 1-3.82 0V7.23H5.32V1.5h9.54l1.87 1.91z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Verkaufsunterlagen_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgVerkaufsunterlagen;